import { render, staticRenderFns } from "./PhotoInNatureCreation.vue?vue&type=template&id=0699eb77&scoped=true&"
import script from "./PhotoInNatureCreation.vue?vue&type=script&lang=js&"
export * from "./PhotoInNatureCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0699eb77",
  null
  
)

export default component.exports